import { connect } from 'react-redux';

import { selectAgentLists } from '../../selectors/offerData/selectAgentLists';
import { IState } from '../../store';
import { getOfferType, isNewbuilding } from '../../utils/offer_type';
import { Description, IDescriptionProps } from './Description';

export const mapStateToProps = (state: IState): IDescriptionProps => {
  const auctionBanks = state.auctionBanks;
  const { offer, agent } = state.offerData;

  const { description, publishedUserId } = offer;

  const offerType = getOfferType(offer);
  const auction = !!publishedUserId && auctionBanks.includes(publishedUserId);

  return {
    description,
    bank: agent?.bank,
    auction,
    isNewbuilding: isNewbuilding(offerType),
    agentLists: selectAgentLists(state),
  };
};

export const DescriptionContainer = connect<IDescriptionProps, {}, {}>(mapStateToProps)(Description);
